import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ExamProvider } from './context/ExamContext';
import { PhonePairingProvider } from './context/PhonePairingContext';
import { ThemeProvider } from './context/ThemeContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider><ExamProvider>
        <PhonePairingProvider><App /></PhonePairingProvider>
      </ExamProvider></ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
